function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { View } from 'react-native';
import * as React from 'react';
export const defaultConfig = {
  themes: []
};
const defaultContextData = defaultConfig;
export const ThemeContext = /*#__PURE__*/React.createContext(defaultContextData);
// Can be discussed should we provide flex 1 by default or not.

export const Theme = ({
  children,
  name,
  ...props
}) => {
  const {
    themes
  } = useTheme();
  const contextValue = React.useMemo(() => {
    return {
      themes: [...themes, name]
    };
  }, [name, themes]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(View, _extends({
    dataSet: {
      'theme-id': name
    }
  }, props), children));
};
// Theme.displayName = 'Theme';

export const useTheme = () => React.useContext(ThemeContext) ?? {
  themes: []
};
//# sourceMappingURL=Theme.js.map